<app-modal
  #openInfo
  [modalType]="'userManuals'"
  [modalTitle]="app.text.sidebar.helpInfo"
  [modalMessage]="app.text.sidebar.info"
  [showButtons]="false"
></app-modal>

<aside
  class="sidebar"
  id="sidebar-wrapper"
  [class.is-expanded]="app.header.showSidebar"
  [class.is-collapsed]="!app.header.showSidebar"
  [attr.aria-label]="app.text.sidebar.mainNavigation"
  >
  <div class="sidebar-heading">
    <div class="brand-lockup">
      @if (!logoLoadFailed) {
        <img
          class="customer-logo"
          [src]="app.logo"
          alt=""
          (error)="onLogoError()"
          />
      }
      @if (logoLoadFailed) {
        <span class="customer-logo-fallback">{{ app.customers.getText() }}</span>
      }
      @if (app.header.showSidebar && app.customers.customers.length > 1) {
        <button
          class="customer-switcher"
          type="button"
          [attr.aria-label]="app.text.sidebar.switchCustomer"
          aria-haspopup="menu"
          [attr.aria-expanded]="customerMenuOpen"
          (click)="toggleCustomerMenu($event)"
          >
          <i class="far fa-angle-down" aria-hidden="true"></i>
        </button>
      }
    </div>

    <button
      class="sidebar-toggle"
      type="button"
      (click)="app.header.toggleSidebar()"
      [attr.aria-label]="app.header.showSidebar ? app.text.sidebar.collapseNavigation : app.text.sidebar.expandNavigation"
      >
      <i
        class="fal"
        [ngClass]="app.header.showSidebar ? 'fa-chevron-double-left' : 'fa-chevron-double-right'"
        aria-hidden="true"
      ></i>
    </button>

    <button class="btn btn-sm btn-close" (click)="app.header.closeNav()" [attr.aria-label]="app.text.sidebar.closeNavigation">
      <i class="fa-light fa-times icon-gray" aria-hidden="true"></i>
    </button>
  </div>

  @if (customerMenuOpen && app.customers.customers.length > 1) {
    <div
      id="customer-menu"
      class="dropdown-menu customer-menu m-0 px-1"
      role="menu"
      >
      <div class="customer-menu-heading">
        <span>{{ app.text.sidebar.customers }}</span>
        <span class="customer-count">{{ customers.length }}</span>
      </div>
      @if (cleanCustomers.length > 2) {
        <div class="searchBar d-flex pt-1">
          <input
            #searchField
            class="form-control searchInput"
            [(ngModel)]="searchedClient"
            (input)="filterCustomers(searchedClient)"
            type="text"
            [placeholder]="app.text.sidebar.search"
            (keydown)="checkKey($event)"
            />
          <i class="fa-regular fa-search p-2" aria-hidden="true"></i>
        </div>
      }
      <div class="customer-menu-list">
        @for (customer of customers; track customer) {
          <button
            #dropdownItem
            class="btn dropdown-item customer-option m-0 my-1"
            [class.current-customer]="customer === app.customers.expectCurrent"
            [attr.aria-current]="customer === app.customers.expectCurrent ? 'page' : null"
            (click)="selectCustomer(customer)"
            (keydown)="checkKey($event)"
            >
            <span>{{ app.customers.getText(customer) }}</span>
            @if (customer === app.customers.expectCurrent) {
              <i
                class="fa-regular fa-check customer-check"
                aria-hidden="true"
              ></i>
            }
          </button>
        }
        @if (customers.length === 0) {
          <div class="customer-empty">
            {{ app.text.sidebar.noCustomersFound }}
          </div>
        }
      </div>
    </div>
  }

  <nav class="sidebar-scroll">
    <section class="nav-section">
      @if (app.permission.graphs.viewDashboard) {
        <li
          class="nav-item"
          [ngClass]="{ active: app.view === 'dashboard' }"
          [title]="app.text.graphs.dashboard"
          (click)="app.routing.navigateDashboard()"
          >
          <a [routerLink]="routerLinkUrl('dashboard')" class="nav-link">
            <span class="nav-icon"><i class="fa-regular fa-grid-2" aria-hidden="true"></i></span>
            <span class="nav-label">{{ app.text.graphs.dashboard }}</span>
          </a>
        </li>
      }
      @if (app.permission.change.seeNotifications) {
        <li
          class="nav-item"
          [ngClass]="{ active: app.view === 'mail' }"
          [title]="app.text.sidebar.notification"
          (click)="app.routing.navigateMail('change'); app.paginator.focus = 0"
          >
          <a [routerLink]="routerLinkUrl('mail/change')" class="nav-link">
            <span class="nav-icon"><i class="fa-regular fa-bell" aria-hidden="true"></i></span>
            <span class="nav-label">{{ app.text.sidebar.notification }}</span>
            @if (app.user != null && unreadCount > 0) {
              <span class="nav-badge">{{ unreadCount }}</span>
            }
          </a>
        </li>
      }
    </section>

    <section class="nav-section">
      <h2 class="nav-section-label">{{ app.text.sidebar.modules }}</h2>

      @if (app.customer === 'oc') {
        <li
          class="nav-item"
          [ngClass]="{ active: app.view === 'oc-home' }"
          [title]="app.text.ocPost.posts"
          (click)="app.routing.navigateOCHome()"
          >
          <a [routerLink]="routerLinkUrl('oc-home')" class="nav-link">
            <span class="nav-icon"><i class="fa-regular fa-folder-open" aria-hidden="true"></i></span>
            <span class="nav-label">{{ app.text.ocPost.posts }}</span>
          </a>
        </li>
      }

      @if (showPortalOMButton()) {
        <li
          class="nav-item"
          [ngClass]="{ active: app.view === 'home' }"
          [title]="app.text.sidebar.cases"
          (click)="app.routing.navigateHome(); app.paginator.focus = 0"
          >
          <a [routerLink]="routerLinkUrl('home')" class="nav-link">
            <span class="nav-icon"><i class="fa-regular fa-folder-open" aria-hidden="true"></i></span>
            <span class="nav-label">{{ app.text.sidebar.cases }}</span>
          </a>
        </li>
      }

      @if (showOMButton()) {
        <li
          class="nav-item"
          [ngClass]="{ active: isOmModuleActive() }"
          [title]="app.text.sidebar.OM"
          (click)="navigateOmModule()"
          >
          <div class="nav-link om-nav-link">
            <a
              class="om-nav-target"
              [routerLink]="routerLinkUrl('home')"
              (click)="navigateOmModule($event)"
              >
              <img
                src="./../assets/om-module-colored.png"
                class="module-logo"
                alt=""
                />
              <span class="nav-label">{{ app.text.sidebar.OM }}</span>
            </a>
            @if (app.permission.post.hasTasks) {
              <button
                class="nav-chevron-button"
                type="button"
                (click)="toggleOmTasks($event)"
                [attr.aria-expanded]="omTasksExpanded"
                [attr.aria-label]="app.text.sidebar.toggleOmDataHandling"
                >
                <i
                  class="nav-chevron far"
                  [ngClass]="omTasksExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                  aria-hidden="true"
                ></i>
              </button>
            }
          </div>
        </li>
      }

      @if (app.permission.post.hasTasks && omTasksExpanded) {
        <section
          class="nav-section om-data-section"
          >
          <h2 class="nav-section-label">{{ app.text.sidebar.omDataHandling }}</h2>
          @if (app.permission.post.hasTasks) {
            <li
              class="nav-item"
              [ngClass]="{ active: app.view === 'tasks' }"
              [title]="app.text.post.tasks"
              (click)="app.routing.navigateTasks()"
              >
              <a [routerLink]="routerLinkUrl('tasks')" class="nav-link">
                <span class="nav-icon"><i class="fa-regular fa-clipboard-check" aria-hidden="true"></i></span>
                <span class="nav-label">{{ app.text.post.tasks }}</span>
                @if (app.tasks.numberOfUncompletedTasks && app.tasks.numberOfUncompletedTasks > 0) {
                  <span class="nav-badge">{{ app.tasks.numberOfUncompletedTasks }}</span>
                }
              </a>
            </li>
          }
        </section>
      }

      @if (app.permission.RM.seeRMModule) {
        <li
          class="nav-item"
          [ngClass]="{ active: isRmModuleActive() }"
          [title]="app.text.sidebar.RM"
          (click)="navigateRmModule()"
          >
          <div class="nav-link rm-nav-link">
            <a
              [routerLink]="routerLinkUrl('rm/tree')"
              class="rm-nav-target"
              (click)="navigateRmModule($event)"
              >
              <img
                src="./../assets/rm-module-colored.png"
                class="module-logo"
                alt=""
                />
              <span class="nav-label">{{ app.text.sidebar.RM }}</span>
            </a>
            <button
              class="nav-chevron-button"
              type="button"
              (click)="toggleRmDataHandling($event)"
              [attr.aria-expanded]="rmDataHandlingExpanded"
              [attr.aria-label]="app.text.sidebar.toggleRmDataHandling"
              >
              <i
                class="nav-chevron far"
                [ngClass]="rmDataHandlingExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </li>
      }
    </section>

    @if (app.customer !== 'oc' && (rmDataHandlingExpanded || !app.permission.RM.seeRMModule) && (app.permission.RM.seeRMModule || app.permission.change.seeNotifications || app.permission.thread.hasPermissionToSeeSeSearch || app.permission.operations.seeOperations || app.permission.businessConfig.seeBusinessConfig)) {
      <section
        class="nav-section"
        >
        <h2 class="nav-section-label">{{ app.text.sidebar.rmDataHandling }}</h2>
        @if (app.permission.RM.seeRMModule) {
          <li
            class="nav-item"
            [ngClass]="{ active: app.view === 'RMSearch' }"
            [title]="app.text.RM.riskManagementSearch"
            (click)="navigateRMSearch()"
            >
            <a [routerLink]="routerLinkUrl('rm/search')" class="nav-link">
              <span class="nav-icon search-mark"><i class="fa-regular fa-search" aria-hidden="true"></i><span class="search-bubble"></span></span>
              <span class="nav-label">{{ app.text.RM.riskManagementSearch }}</span>
            </a>
          </li>
        }
        @if (app.permission.thread.hasPermissionToSeeSeSearch) {
          <li
            class="nav-item"
            [ngClass]="{ active: app.view === 'external-data-filter' }"
            [title]="app.text.sidebar.searchInComponent"
            (click)="app.routing.navigateExternalDataFilter()"
            >
            <a class="nav-link" [routerLink]="routerLinkUrl('external-data-filter')">
              <span class="nav-icon"><i class="fab fa-searchengin" aria-hidden="true"></i></span>
              <span class="nav-label">{{ app.text.sidebar.searchInComponent }}</span>
            </a>
          </li>
        }
        @if (app.permission.operations.seeOperations) {
          <li
            class="nav-item"
            [ngClass]="{ active: app.view === 'operations' }"
            [title]="app.text.operations.operations"
            (click)="app.routing.navigateOperations(); app.paginator.focus = 0"
            >
            <a class="nav-link" [routerLink]="routerLinkUrl('operations')">
              <span class="nav-icon"><i class="fa-regular fa-toolbox" aria-hidden="true"></i></span>
              <span class="nav-label">{{ app.text.operations.operations }}</span>
            </a>
          </li>
        }
        @if (app.permission.businessConfig.seeBusinessConfig) {
          <li
            class="nav-item"
            [ngClass]="{ active: app.view === 'business-config' }"
            [title]="app.text.businessConfig.title"
            (click)="app.routing.navigateBusinessConfig(); app.paginator.focus = 0"
            >
            <a [routerLink]="routerLinkUrl('business-config')" class="nav-link">
              <span class="nav-icon"><i class="fa-regular fa-gears" aria-hidden="true"></i></span>
              <span class="nav-label">{{ app.text.businessConfig.title }}</span>
            </a>
          </li>
        }
      </section>
    }

    @if (app.permission.app.import || app.permission.exportData.view) {
      <section class="nav-section">
        <h2 class="nav-section-label">{{ app.text.sidebar.data }}</h2>
        @if (app.permission.app.import) {
          <li
            class="nav-item"
            [ngClass]="{ active: app.view === 'import' }"
            [title]="app.text.sidebar.import"
            (click)="app.routing.navigateImport()"
            >
            <a [routerLink]="routerLinkUrl('import')" class="nav-link">
              <span class="nav-icon"><i class="fa-regular fa-upload" aria-hidden="true"></i></span>
              <span class="nav-label">{{ app.text.sidebar.import }}</span>
            </a>
          </li>
        }
        @if (app.permission.exportData.view) {
          <li
            class="nav-item"
            [ngClass]="{ active: app.view === 'export-data' }"
            [title]="app.text.sidebar.export"
            (click)="app.routing.navigateExportData()"
            >
            <a [routerLink]="routerLinkUrl('export-data')" class="nav-link">
              <span class="nav-icon"><i class="fa-regular fa-download" aria-hidden="true"></i></span>
              <span class="nav-label">{{ app.text.sidebar.export }}</span>
            </a>
          </li>
        }
      </section>
    }

    <section class="nav-section">
      <h2 class="nav-section-label">{{ app.text.sidebar.account }}</h2>

      <li
        class="nav-item"
        [ngClass]="{ active: app.view === 'profile' }"
        [title]="app.text.sidebar.profile"
        (click)="navigateUserProfile()"
        >
        <a [routerLink]="routerLinkUrl('profile')" class="nav-link">
          @if (app.profile.ownProfilePicture == null) {
            <span class="nav-icon"><i class="fa-regular fa-user" aria-hidden="true"></i></span>
          }
          @if (app.profile.ownProfilePicture != null) {
            <img class="nav-profile-image" [src]="app.file.getUrl(app.profile.ownProfilePicture)" [alt]="app.user" />
          }
          <span class="nav-label">{{ app.text.sidebar.profile }}</span>
        </a>
      </li>

      @if (app.permission.app.users || app.auth.isTeam) {
        <li
          class="nav-item"
          [ngClass]="{ active: app.view === 'users' || app.view === 'user' }"
          [title]="app.text.sidebar.users"
          (click)="app.routing.navigateUsers(); app.paginator.focus = 0"
          >
          <a [routerLink]="routerLinkUrl('users')" class="nav-link">
            <span class="nav-icon"><i class="fa-regular fa-users-cog" aria-hidden="true"></i></span>
            <span class="nav-label">{{ app.text.sidebar.users }}</span>
          </a>
        </li>
      }

      @if ((app.customer === 'omp' || app.customer === 'oc') && app.permission.personProfile.see) {
        <li
          class="nav-item"
          [ngClass]="{ active: app.view === 'user-profile-list' }"
          [title]="app.text.app.userList"
          (click)="app.routing.navigateUserProfiles(); app.paginator.focus = 0"
          >
          <a class="nav-link">
            <span class="nav-icon"><i class="fa-regular fa-users" aria-hidden="true"></i></span>
            <span class="nav-label">{{ app.text.app.userList }}</span>
          </a>
        </li>
      }

      <li
        class="nav-item"
        [title]="app.text.sidebar.logout"
        (click)="app.auth.logout()"
        >
        <a id="logout-button" class="nav-link">
          <span class="nav-icon"><i class="fa-regular fa-sign-out-alt" aria-hidden="true"></i></span>
          <span class="nav-label">{{ app.text.sidebar.logout }}</span>
        </a>
      </li>
    </section>

    @if (app.customer !== 'oc') {
      <section class="nav-section">
        <h2 class="nav-section-label">{{ app.text.sidebar.support }}</h2>
        <li
          class="nav-item"
          [title]="app.text.sidebar.help"
          (click)="openInfo.open()"
          >
          <a class="nav-link">
            <span class="nav-icon"><i class="far fa-question-circle" aria-hidden="true"></i></span>
            <span class="nav-label">{{ app.text.sidebar.help }}</span>
          </a>
        </li>
      </section>
    }
  </nav>

</aside>
